import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "homeszig-cookie-consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 z-[45] mx-auto max-w-xl border border-white/10 bg-brand-primary p-4 text-white shadow-[0_20px_50px_rgba(10,37,64,0.4)] max-lg:bottom-[4.75rem] sm:p-6 md:left-6 md:right-auto md:bottom-6"
        >
          <div className="flex items-start gap-3 sm:gap-4">
            <span className="hidden h-10 w-10 shrink-0 place-items-center bg-brand-accent/15 text-brand-accent sm:grid">
              <Cookie size={20} />
            </span>
            <div className="flex-1">
              <h4 className="flex items-center gap-2 font-heading text-sm font-bold sm:text-base">
                <Cookie size={16} className="text-brand-accent sm:hidden" />
                Sütikezelés
              </h4>
              <p className="mt-1.5 text-[13px] leading-snug text-white/65 sm:text-sm">
                Weboldalunk sütiket használ a legjobb felhasználói élmény érdekében. A
                böngészés folytatásával elfogadja a sütik használatát.
              </p>
              <div className="mt-3.5 flex gap-3 sm:mt-4">
                <button
                  data-testid="cookie-accept"
                  onClick={() => decide("accepted")}
                  className="flex-1 bg-brand-accent px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-accentDark sm:flex-none sm:px-5"
                >
                  Elfogadom
                </button>
                <button
                  data-testid="cookie-decline"
                  onClick={() => decide("declined")}
                  className="flex-1 border border-white/25 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-white/10 sm:flex-none sm:px-5"
                >
                  Csak a szükségeseket
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
